import script from "./OneWebshopOrdersWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./OneWebshopOrdersWidget.vue?vue&type=script&setup=true&lang=js"

import "./OneWebshopOrdersWidget.vue?vue&type=style&index=0&id=735e3f18&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-735e3f18"]])

export default __exports__